import { render, staticRenderFns } from "./RevenueShow.vue?vue&type=template&id=962df5cc&scoped=true"
import script from "./RevenueShow.vue?vue&type=script&lang=js"
export * from "./RevenueShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962df5cc",
  null
  
)

export default component.exports